import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=222bde06&scoped=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=222bde06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222bde06",
  null
  
)

export default component.exports